const linkItems = [
  { url: 'https://cdto.ranepa.ru/program-registry', text: 'Образование'},
  { anchor: 'career-section', text: 'Рекрутинговый центр'},
  { anchor: 'home-ai', text: 'ИИ-зрелость'},
  { anchor: 'expert-materials-section', text: 'Экспертные материалы'},
  { anchor: 'commercial-projects-section', text: 'Коммерческие проекты'}
]

export { linkItems }
